module.exports = __webpack_public_path__ + "static/media/mobile-btn-download-android.d5a02c3a.svg";